<template>
  <div class="infographicSection">
    <div :class="hasInvertedLayout ? 'orderSecond' : 'orderFirst'" class="infoContent">
      <div :class="hasWhiteText && 'whiteText'" class="textAndCtaWrapper">
        <h1 :class="hasMainHeadingTitle ? 'headingTitle' : 'infographicTitle'">{{ title }}</h1>
        <p class="infographicText">{{ paragraph }}</p>

        <button v-if="buttonText" :class="buttonClassName" class="infographicButton" @click="onButtonClick?.()">
          {{ buttonText }}
        </button>
      </div>
    </div>

    <div :class="hasInvertedLayout ? 'orderFirst' : 'orderSecond'" class="graphicContent">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { bool, func, string } from 'vue-types'

defineProps({
  hasWhiteText: bool().def(false),
  hasInvertedLayout: bool().def(false),
  title: string().def('').isRequired,
  paragraph: string().def(''),
  buttonClassName: string().def('btn-round-yellow'),
  buttonText: string(),
  onButtonClick: func(),
  hasMainHeadingTitle: bool().def(false),
})
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';
@import 'assets/scss/base/functions';

.infographicSection {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;

  @media (min-width: $screen-sm-min) {
    flex-direction: row;
    gap: 2%;
  }

  .infoContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    order: 2;
    text-align: center;

    @media (min-width: $screen-sm-min) {
      flex: 0 1 36.8%;
      margin-top: 80px;
      text-align: left;
    }

    .textAndCtaWrapper {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      max-width: 460px;
      color: $color-black;

      .infographicTitle {
        font-size: to-rem(28);
        font-weight: 400;
        line-height: 1.1;
        color: inherit;

        @media (min-width: $screen-sm-min) {
          font-size: to-rem(48);
        }
      }

      .headingTitle {
        font-size: to-rem(34);
        font-weight: 400;
        line-height: 1.1;
        color: inherit;
        text-align: center;

        @media (min-width: $screen-sm-min) {
          font-size: to-rem(52);
          text-align: left;
        }
      }

      .infographicText {
        max-width: 500px;
        margin-top: 32px;
        font-size: to-rem(16);
        line-height: 1.5;
        color: inherit;

        @media (min-width: $screen-sm-min) {
          font-size: to-rem(20);
        }
      }

      .infographicButton {
        margin: 48px auto 0;

        @media (min-width: $screen-sm-min) {
          margin: 48px 0 0;
        }
      }
    }

    & .whiteText {
      color: $color-white;
    }
  }

  .graphicContent {
    display: flex;
    align-items: center;
    order: 1;
    margin-top: 64px;

    @media (min-width: $screen-sm-min) {
      flex: 1;
      max-width: 61.2%;
    }
  }

  .orderFirst {
    order: inherit;

    @media (min-width: $screen-sm-min) {
      order: 1;
    }
  }

  .orderSecond {
    order: inherit;

    @media (min-width: $screen-sm-min) {
      order: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// InfographicSection.vue